// types are not entirely correct, but they seem to work for now
function getObjectValueArray<TObject extends object, TKey extends keyof TObject>(
    obj: TObject | null | undefined,
    keys: TKey[],
) {
    if (obj === null || obj === undefined) {
        return undefined;
    }

    const key = keys[0];
    const value = obj[key];

    keys.shift();

    if (keys.length === 0) {
        return value;
    }

    if (typeof value !== "object" || value === null) {
        return undefined;
    }

    return getObjectValueArray(value, keys as (keyof typeof value)[]);
}

export default function getObjectValue<TObject extends object>(
    obj: TObject,
    parameterPath: string,
) {
    const keys = parameterPath.split(".");

    return getObjectValueArray(obj, keys as (keyof TObject)[]);
}
